import { formatDistanceToNow } from 'date-fns';
import fileDownload from 'js-file-download';
import moment from 'moment/moment';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import { ajaxErrorHandler, toTitleCase } from '../../../../libs/utils';
import { downloadInstance } from '../../../../services/api';
import { triggerReport } from '../../../../services/api/reporting';

const ExportCard = ({ report, eventId }) => {
  const [loading, setLoading] = useState(false);
  const [inProgress, setInProgress] = useState(report.inProgress);

  useEffect(() => {
    // Only change state if the report was generated in the last minute. This avoids setting inProgress to false when the queue hasn't started yet.
    if (new Date(report.lastGeneratedAt + 'Z') > new Date(Date.now() - 60000)) {
      setInProgress(report.inProgress);
    }
  }, [report]);

  const generate = () => {
    if (inProgress) return;

    triggerReport(eventId, report.name).catch((e) => {
      ajaxErrorHandler(e);
      setInProgress(false);
    });

    setInProgress(true);
  };

  const download = () => {
    setLoading(true);

    downloadInstance({
      method: 'get',
      url: report.downloadUrl,
      responseType: 'blob',
    })
      .then((response) => {
        fileDownload(
          response.data,
          report.name + moment().format('DD-MM-YYY-HH-mm-ss') + '.' + (report.extension ? report.extension : 'xlsx')
        );
      })
      .catch(ajaxErrorHandler)
      .then(() => {
        setLoading(false);
      });
  };

  return (
    <div className="border-bottom mb-5 pb-5">
      <div>
        <h4>{report.label ? report.label : toTitleCase(report.name.replace(/_/g, ' '))}</h4>
      </div>
      {!report.lastGeneratedAt && (
        <span className="lastgen">
          <strong>Not exported yet</strong>
        </span>
      )}
      {report.lastGeneratedAt && (
        <span className="lastgen">
          Exported{' '}
          <strong>
            {formatDistanceToNow(new Date(report.lastGeneratedAt + 'Z'), {
              addSuffix: true,
            })}
          </strong>
        </span>
      )}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'min-content min-content auto',
          gap: '1rem',
        }}
        className="mt-3"
      >
        {report.lastGeneratedAt && (
          <button
            className={'btn m-btn m-btn--icon btn-success' + (loading ? ' m-loader m-loader--left' : '')}
            type="button"
            onClick={download}
          >
            <span>
              <i className="la la-download" />
              <span>Download report</span>
            </span>
          </button>
        )}

        <button
          className={'btn m-btn m-btn--icon btn-warning' + (inProgress ? ' m-loader m-loader--left' : '')}
          type="button"
          disabled={inProgress}
          onClick={generate}
        >
          <span>
            <i className="la la-refresh" />
            <span>{inProgress ? 'Generating new export...' : 'Generate new export'}</span>
          </span>
        </button>
      </div>
    </div>
  );
};

ExportCard.propTypes = {
  report: PropTypes.object,
  eventId: PropTypes.number,
};

export default ExportCard;
